module.exports = __webpack_public_path__ + "img/img1.b35126bd.png";